module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0104.jpg?v=d28aa2f8";